import { useState, useEffect, useCallback } from "react";
import type { ToolbarProps } from "./Toolbar.types";
import { TOOLBAR_MARGIN_TOP } from "./Toolbar.constants";

type UseToolbarProps = Pick<ToolbarProps, "pageDimensions" | "pdfContainerRef">;

export const useToolbar = ({
  pageDimensions,
  pdfContainerRef
}: UseToolbarProps) => {
  const [currentPage, setCurrentPage] = useState(1);

  const handleScroll = useCallback(() => {
    const topPadding = pdfContainerRef?.current?.offsetTop ?? 0;
    const containerTop =
      pdfContainerRef?.current?.getBoundingClientRect().top ?? 0;
    const scrollTop = -1 * (containerTop - TOOLBAR_MARGIN_TOP - topPadding);

    let accumulatedHeight = 0;

    // Find current page based on scroll position
    for (const [pageIndex, dimensions] of Object.entries(pageDimensions)) {
      accumulatedHeight += dimensions.height;

      if (scrollTop < accumulatedHeight) {
        setCurrentPage(parseInt(pageIndex) + 1);
        break;
      }
    }
  }, [pageDimensions, pdfContainerRef]);

  useEffect(() => {
    handleScroll();
    window.addEventListener("scroll", handleScroll, true);

    // Clean up
    return () => {
      window.removeEventListener("scroll", handleScroll, true);
    };
  }, [handleScroll]);

  return {
    currentPage
  };
};
